import { render, staticRenderFns } from "./collectItem.vue?vue&type=template&id=094cd075&"
import script from "./collectItem.vue?vue&type=script&lang=js&"
export * from "./collectItem.vue?vue&type=script&lang=js&"
import style0 from "./collectItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports